module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Flower3-8d8e640056e62da49b93e59877312451.svg";